import react, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import AddIcon from '@mui/icons-material/Add';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';

import { makeStyles } from '@mui/styles';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view';
import { activate_da_wf_steps, get_all_categories, get_all_services, get_da_wf_process_steps } from '../../../services/company_admin_service';
import DA_wf_configuration_modal from './da_wf_configuration_modal/da_wf_configuration_modal';
import { get_directions } from '../../../services/for_allServices';


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

const columns = [
    { id: 'directions', label: "Directions", minWidth: 0 },
    { id: 'categories_ids', label: "Familles d'achats", minWidth: 0 },
    { id: 'users', label: "Utilisateurs", minWidth: 0 },
    { id: 'step', label: "Etape", minWidth: 0 },
    { id: 'step_type', label: "Type d'étape", minWidth: 0 },
    { id: 'threshold', label: "Seuil", minWidth: 0 },
    { id: 'operator', label: "Opération", minWidth: 0 },
    { id: 'active', label: "Statut", minWidth: 0 }
];

function get_users_infos(id_users, users) {
    let user_infos = [];
    let users_names = "";
    id_users.map((id_user) => {
        user_infos = users.filter((usr) => usr.id == id_user);
        users_names += (users_names == "" ? "" : ", ") + user_infos[0]?.fullName;
    })
    return users_names;
}

function get_categories_infos(categories_ids, categories) {
    let category_infos = [];
    let categories_names = "";
    categories_ids.map((cat_id) => {
        category_infos = categories.filter((cat) => cat.id_category == cat_id);
        categories_names += (categories_names == "" ? "" : ", ") + category_infos[0]?.name;
    })
    return categories_names;
}

function get_directions_infos(directions_ids, directions) {
    let dir_infos = [];
    let dir_titles = "";
    directions_ids.map((dir_id) => {
        dir_infos = directions.filter((dir) => dir.id == dir_id);
        dir_titles += (dir_titles == "" ? "" : ", ") + dir_infos[0]?.title;
    })
    return dir_titles;
}

function state(active) {
    return (
        <>
            {
                active === 1
                    ? <Button variant="contained" className="status_success">{"activée"}</Button>
                    : <Button variant="contained" className="status_deny">{"désactivée"}</Button>
            }
        </>
    );
}

const step_types = [
    {
        "type": "validation",
        "label": "Validation"
    },
    {
        "type": "signature",
        "label": "Signature"
    }];

const wf_default_steps = [
    {
        "step": "at_creation",
        "label": "Après la création"
    },
    {
        "step": "threshold",
        "label": "Seuil"
    }];

const operators = [
    {
        "value": ">",
        "label": "Supérieur à"
    },
    {
        "value": "<=",
        "label": "Inférieur ou égal à"
    }];


function Steps({ wf_steps, activate, setadd_infos_modal, setupdate_wf_step, users, directions, categories }) {
    return (
        <>
            {
                wf_steps.map((wf_step, id) => (
                    <TableRow key={"wf_step" + id}>
                        <TableCell align="left">
                            <div style={{ width: 'fit-content' }}>
                                {wf_step.directions?get_directions_infos(JSON.parse(wf_step.directions), directions):""}
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Tooltip title="modifier" placement="top" >
                                        <span className={"editIcon"} onClick={() => { setupdate_wf_step(wf_step); setadd_infos_modal(true) }} >
                                            <EditIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="left"> {get_categories_infos(JSON.parse(wf_step.categories_ids), categories)}
                        </TableCell>
                        <TableCell align="left">  {get_users_infos(JSON.parse(wf_step.users), users)} </TableCell>
                        <TableCell align="left">  {wf_step.step} </TableCell>
                        <TableCell align="left">  {wf_step.step_type} </TableCell>
                        <TableCell align="left">  {wf_step.threshold} </TableCell>
                        <TableCell align="left">  {wf_step.operator} </TableCell>
                        <TableCell align="center">
                            <div className='documentsStatus_valide'  >
                                <div>
                                    <div><CheckIcon className="checkIcon" onClick={() => activate(id, wf_step.id, 1)} /></div>
                                    <div><CloseSharpIcon className="closeSharpIcon" onClick={() => activate(id, wf_step.id, 0)} /></div>
                                </div>
                                {state(wf_step.active)}
                            </div>
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    );
}


const DA_wf_steps = () => {
    const classes = useStyles();
    let history = useHistory();
    const [url_updated, setUrl_updated] = useState(null);

    const [waiting, setWaiting] = useState(false);

    const [wf_steps, setWf_steps] = useState(null)
    const [users, setUsers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [directions, setDirections] = useState([]);
    const [update_wf_step, setupdate_wf_step] = useState(null);
    const [add_infos_modal, setadd_infos_modal] = useState(false);

    useEffect(() => {
        async function load_data() {
            await get_all_categories().then((response) => {
               //  console.log(response.data);
                setCategories(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            });
            await get_all_services().then((response) => {
               //  console.log(response.data);
                setUsers(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            });
            await get_directions().then((response) => {
                setDirections(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            });

            await get_da_wf_process_steps().then((response) => {
               //  console.log("da_wfs : ", response.data);
                setWf_steps(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            })


        }
        load_data();
    }, []);

    async function activate(id, wf_step_id, activated_it) {
       //  console.log(id, wf_step_id, activated_it);
        setWaiting(true);
        let formData = new FormData();
        formData.append("active", activated_it);
        formData.append("id", wf_step_id);
        await activate_da_wf_steps(formData).then((response) => {
           //  console.log(response.data);
            let tmp_arr = [...wf_steps];
            tmp_arr[id].active = activated_it;
            setWf_steps(tmp_arr);
        }).catch((error) => {
           //  console.log(error.response);
        })
        setWaiting(false);
    }

    return (
        <>
            {
                wf_steps == null
                    ? <Loading_animation_view />
                    : <div className='categories_list_container'>
                        <div className='categories_list_container_header'>
                            <div className='title_container'>
                                <Button variant="contained" startIcon={<AddIcon className="my_icon" />} className={waiting ? "submit_but disabled_button" : "submit_but"} onClick={() => setadd_infos_modal(true)}>
                                    Ajouter
                                </Button>
                            </div>
                        </div>
                        <TableContainer className="services_list_container" >
                            <Table className={classes.table} aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map((column) => (
                                                <TableCell key={column.id} align="left">{column.label}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        wf_steps.length !== 0
                                            ?
                                            <>
                                                {
                                                    <Steps wf_steps={wf_steps} activate={activate} directions={directions} categories={categories}
                                                        setupdate_wf_step={setupdate_wf_step} setadd_infos_modal={setadd_infos_modal} users={users} />
                                                }

                                            </>
                                            : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucune famille disponible</div>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {/*
                            wf_steps.length !== 0
                                ? <div className="pagination_container">
                                    <Pagination
                                        activePage={Number(currentPage)}
                                        itemsCountPerPage={dataPerPage}
                                        totalItemsCount={Number(data_count)}
                                        pageRangeDisplayed={4}
                                        onChange={change_page.bind(this)}
                                    />
                                </div>
                                : <></>*/
                        }
                    </div>
            }

            {
                add_infos_modal != false
                    ? <DA_wf_configuration_modal directions={directions} add_infos_modal={add_infos_modal} setadd_infos_modal={setadd_infos_modal}
                        app_users={users} app_categories={categories} step_types={step_types} update_wf_step={update_wf_step}
                        setupdate_wf_step={setupdate_wf_step} wf_default_steps={wf_default_steps} operators={operators} />
                    : <></>
            }

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default DA_wf_steps;